export default "__VITE_ASSET__CLxgqhG4__"